export const getDesktopBreakpoints = (windowWidth) => {
  const handleResizeWindow = () => windowWidth;
  // subscribe to window resize event "onComponentDidMount"
  window.addEventListener('resize', handleResizeWindow);
  return () => {
    // unsubscribe "onComponentDestroy"c
    window.removeEventListener('resize', handleResizeWindow);
  };
};
